// Contracts Договоры клиентов аутстафф
import React, { useState, useEffect } from "react";
import { Col, Row, Modal } from 'antd';
import { Toaster } from 'react-hot-toast'; // notifications

// Zustand store
import { useShallow } from 'zustand/react/shallow';
import { useOutStaff, useContractsStore, useTemplatesStore, useCustomersOutstaff, useCompaniesStore } from 'storeZustand';
import { getUser } from 'services';
import { useSearchContractsParams } from 'hooks';
import CustomRadio from 'components/Common/CustomRadio';
import CustomRadioDate from './customRadioDate';
import SearchInput from 'components/Common/SearchInput';
import CustomRadioSearchParams from './customRadioSearchParams';
import ContractsTable from './contractsTable';
import { PrimaryBtn } from 'components';
import CollapseFilters from './filters/collapseFilters';
import ContractTabs from './contractTabs';

const cities = [
	{ value: 'Москва', label: 'Москва' },
	{ value: 'Химки', label: 'Химки' },
];

const Contracts = () => {
	document.title = "Contracts List";

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [selectedCity, setSelectedCity] = useState('');
	const [isOutstaffPers, setIsOutstaffPers] = useState(false);

	// Поиск договоров по параметрам
	const { handleSearchParams, onSearch } = useSearchContractsParams();

	const [
		clearUploadFilesList
	] = useOutStaff(useShallow((state) => [
		state.clearUploadFilesList
	]),)

	// Договоры клиента
	const [
		clearContract,
		clearContractId,
		addFilter
	] = useContractsStore(useShallow((state) => [
		state.clearContract,
		state.clearContractId,
		state.addFilter
	]));

	// Очистка компании оптовик
	const [
		clearSelectedExternalCompany
	] = useCompaniesStore(useShallow((state) => [
		state.clearSelectedExternalCompany
	]));

	useEffect(() => {
		const fetchUserData = async () => {
			try {
				const userData = await getUser();
				const isOutstaffPers = userData?.staff?.department === 16;
				setIsOutstaffPers(isOutstaffPers);

				if (selectedCity === '') {
					isOutstaffPers
						? setSelectedCity('Санкт-Петербург')
						: setSelectedCity('Москва');
				}
			} catch (error) {
				console.error('Error fetching user data:', error);
			}
		}

		fetchUserData();
	}, []);

	// Шаблоны
	const [
		clearSelectedTemplateSet // очистка набора шаблонов
	] = useTemplatesStore(useShallow((state) => [
		state.clearSelectedTemplateSet
	]));

	// Клиенты, очистить id
	const [
		clearCustomerOutstaffId
	] = useCustomersOutstaff(useShallow((state) => [
		state.clearCustomerOutstaffId
	]))

	// Очистка всех форм при закрытии окна
	const clearForms = () => {
		clearContract();
		clearContractId(); // очистить id договора
		clearUploadFilesList(); // очистить список загруженных файлов
		clearCustomerOutstaffId(); // очистить id клиента
		clearSelectedTemplateSet(); // очистка набора шаблонов
		clearSelectedExternalCompany();
	}

	const toggleModal = () => {
		setIsModalOpen(!isModalOpen);
		clearForms();
	}

	// Добавить договор
	const handleContractAdd = async () => {
		clearContract(); // очистить договор
		clearContractId(); // очистить id договора
		toggleModal();
		setIsEdit(false);
	}

	// Выбор города
	const handleCityChange = (event) => {
		const value = event.target.value;
		setSelectedCity(value);

		addFilter({ city: value });
	};

	return (
		<>
			<div className="page-content">
				<div className="container-fluid">
					<Row className='mb-2 align-items-center'>
						<Col span={8}>
							<Row gutter={2}>
								<Col span={12}>
									<CustomRadioDate selectedCity={selectedCity} />
								</Col>
								<Col span={12}>
									{!isOutstaffPers && <CustomRadio defaultValue="Москва"
										onChange={handleCityChange}
										options={cities}
									/>}
								</Col>
							</Row>
						</Col>
						<Col span={13}>
							<Row gutter={8} className='justify-content-end'>
								<Col span={9}>
									<CustomRadioSearchParams onChange={handleSearchParams} />
								</Col>

								<Col span={7}>
									<SearchInput onSearch={onSearch} />
								</Col>
							</Row>
						</Col>
						<Col span={3} className="text-end">
							<PrimaryBtn onClick={handleContractAdd}>
								Создать договор
							</PrimaryBtn>
						</Col>
					</Row>

					<Row className='mb-2'>
						<Col span={24}>
							{/* Аккордион с фильтрами */}
							<CollapseFilters selectedCity={selectedCity} />
						</Col>
					</Row>
					<Row>
						<Col span={24}>
							<ContractsTable
								setIsEdit={setIsEdit}
								toggleModal={toggleModal}
							/>
						</Col>
					</Row>

					<Modal
						title='Создание договора'
						open={isModalOpen}
						onCancel={toggleModal}
						width={800}
						footer={null}
					>
						<ContractTabs isEdit={isEdit} selectedCity={selectedCity} />
					</Modal>
				</div>
			</div >
			<Toaster position="top-right"
				reverseOrder={true} />
		</>
	)
};

export default Contracts;
